import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AlarmActionTypes, AlarmActionsUnion, AlarmLocationModel } from './alarm.actions';

export const inRoomAlarmFeatureKey = 'inroom-alarm';

export type AlarmState = EntityState<AlarmLocationModel>;

export function selectAlarmIdFromAlarm(alarm: AlarmLocationModel): string {
  return selectAlarmId(alarm.hotelCode, alarm.room);
}

export function selectAlarmId(hotelCode: string, room: string): string {
  return hotelCode + '-' + room;
}

export const adapter: EntityAdapter<AlarmLocationModel> = createEntityAdapter<AlarmLocationModel>({
  selectId: selectAlarmIdFromAlarm,
});

export const initialState: AlarmState = adapter.getInitialState();

export function alarmReducer(state: AlarmState = initialState, action: AlarmActionsUnion): AlarmState {
  switch (action.type) {
    case AlarmActionTypes.ALARM_API_ALARM_LOADED:
      return adapter.addOne(action.payload, state);
    case AlarmActionTypes.ALARM_SIGNALR_STATE_CHANGE:
      return adapter.updateOne(action.payload, state);
    case AlarmActionTypes.ALARM_EFFECT_ALARM_RESETTED:
      return adapter.updateOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAlarmIds = selectIds;

export const selectAlarmEntities = selectEntities;

export const selectAllAlarms = selectAll;
